import React from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import '../styles/applyHere.css';

const ApplyHere = () => {
  return (
    <div className="apply-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="apply-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Apply to Join Our Team</h1>
          <p>Browse our current openings and submit your application</p>
          <Link to="/" className="btn-cta hero-cta-button">
            Back to Home
          </Link>
        </div>
      </section>
      
      <div className="apply-content">
        
        {/* BambooHR Job Listings */}
        <section className="jobs-section">
          <div className="jobs-container">
            <div className="bamboo-embed-wrapper">
              <iframe 
                src="https://allseasons.bamboohr.com/careers" 
                width="100%" 
                height="600"
                style={{ 
                  border: 'none',
                  borderRadius: '8px',
                  display: 'block',
                  background: '#f5f5f5'
                }}
                title="All Seasons Job Applications"
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </div>
      
    </div>
  );
};

export default ApplyHere;